<template>
  <div>
    <el-radio-group v-model="path"  size="medium" @change="tabPath">
      <el-radio-button label="/recipeStatistics/prescriptionAnalysis/operator">代理商处方量分析</el-radio-button>
      <el-radio-button label="/recipeStatistics/prescriptionAnalysis/workload">人员工作量分析</el-radio-button>
      <el-radio-button label="/recipeStatistics/prescriptionAnalysis/equipment">设备工作量分析</el-radio-button>
      <el-radio-button label="/recipeStatistics/prescriptionAnalysis/prescriptionData">处方数据列表</el-radio-button>
    </el-radio-group>
    <div style="margin-top: 20px">
      <keep-alive>
        <router-view v-if='$route.meta.keepAlive'></router-view>
      </keep-alive>
      <router-view v-if='!$route.meta.keepAlive'></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "anomaly",
  data() {
    return {
      path: "/recipeStatistics/prescriptionAnalysis/operator"
    }
  },
  created() {
    this.path=this.$route.path
  },
  component: {
    //someComponent
  },
  methods: {
    //
    tabPath(){
      this.$router.push(this.path)
    }
  },
  mounted() {
    //
  }
}
</script>

<style lang="scss" scoped>
.index {

}
</style>